import React from 'react';
import { DashboardOverview } from '../components/dashboard';

const Dashboard = () => (
  <DashboardOverview />
);

export default Dashboard;